import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './ViewQuickLoanReport.css';

const ViewQuickLoanReport = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const loan = location.state?.loan;

    // Base URL for images
    const BASE_URL = "https://payyug.in/";

    if (!loan) {
        return (
            <div className="view-report-error">
                <h3>No data available</h3>
                <button onClick={() => navigate(-1)}>Go Back</button>
            </div>
        );
    }

    return (
        <div className="view-report-container">
            <div className="view-report-card">
                <div className="view-report-header">
                    <button className="back-btn" onClick={() => navigate(-1)}>← Back</button>
                    <h2>Application Details - ID: {loan.id}</h2>
                    <span className={`status-tag ${(loan.status || 'pending').toLowerCase()}`}>
                        {loan.status || 'Pending'}
                    </span>
                </div>

                <div className="report-grid">
                    {/* Section 1: Personal Information */}
                    <section className="detail-section">
                        <h3>Personal Information</h3>
                        <div className="info-item"><span>Full Name:</span> <p>{loan.fullName}</p></div>
                        <div className="info-item"><span>Email:</span> <p>{loan.email}</p></div>
                        <div className="info-item"><span>Mobile:</span> <p>{loan.mobile}</p></div>
                        <div className="info-item"><span>DOB:</span> <p>{loan.dob}</p></div>
                        <div className="info-item"><span>Gender:</span> <p>{loan.gender}</p></div>
                        <div className="info-item"><span>PAN:</span> <p>{loan.pan}</p></div>
                        <div className="info-item"><span>Aadhar:</span> <p>{loan.aadhar || 'N/A'}</p></div>
                        <div className="info-item"><span>Address:</span> <p>{loan.addressLine}, {loan.city}, {loan.state}</p></div>
                    </section>

                    {/* Section 2: Employment & Loan */}
                    <section className="detail-section">
                        <h3>Employment & Loan Details</h3>
                        <div className="info-item"><span>Type:</span> <p>{loan.employmentType}</p></div>
                        <div className="info-item"><span>Company:</span> <p>{loan.companyName}</p></div>
                        <div className="info-item"><span>Experience:</span> <p>{loan.workExperienceYears} Years</p></div>
                        <div className="info-item"><span>Income:</span> <p>₹{loan.monthlyIncome?.toLocaleString()}</p></div>
                        <hr />
                        <div className="info-item highlight"><span>Loan Type:</span> <p>{loan.loanType}</p></div>
                        <div className="info-item highlight"><span>Amount:</span> <p>₹{loan.loanAmount?.toLocaleString()}</p></div>
                        <div className="info-item"><span>Tenure:</span> <p>{loan.loanTenureMonths} Months</p></div>
                        <div className="info-item"><span>Purpose:</span> <p>{loan.loanPurpose}</p></div>
                    </section>

                    {/* Section 3: Banking & References */}
                    <section className="detail-section">
                        <h3>Banking & References</h3>
                        <div className="info-item"><span>Bank:</span> <p>{loan.bankName || "NA"}</p></div>
                        <div className="info-item"><span>Account:</span> <p>{loan.accountNumber || "NA"}</p></div>
                        <div className="info-item"><span>IFSC:</span> <p>{loan.ifscCode || "NA"}</p></div>
                        <hr />
                        <div className="info-item"><span>Ref 1:</span> <p>{loan.reference1Name || "NA"} ({loan.reference1Mobile || "NA"})</p></div>
                        <div className="info-item"><span>Ref 2:</span> <p>{loan.reference2Name || "NA"} ({loan.reference2Mobile  || "NA"})</p></div>
                    </section>

                    {/* Section 4: Documents */}
                    <section className="detail-section document-section">
                        <h3>Uploaded Documents</h3>
                        <div className="doc-grid">
                            <div className="doc-item">
                                <span>Salary Slip:</span>
                                {loan.salarySlipPath ? (
                                    <img src={`${BASE_URL}${loan.salarySlipPath}`} alt="Salary Slip" className="doc-preview" />
                                ) : <p className="no-doc">No Image Uploaded</p>}
                            </div>
                            {/* <div className="doc-item">
                                <span>ID Proof:</span>
                                {loan.idProofPath ? (
                                    <img src={`${BASE_URL}${loan.idProofPath}`} alt="ID Proof" className="doc-preview" />
                                ) : <p className="no-doc">No Image Uploaded</p>}
                            </div> */}
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default ViewQuickLoanReport;



